/**
 * Product Recommendations Section
 * Fetches recommendations via Shopify's section rendering API
 * when server-side rendering hasn't populated the content.
 */
(() => {
  const recommendationsContainer = document.querySelector('[data-recommendations]');
  if (!recommendationsContainer) return;

  const { productId, limit = '3', intent = 'related', sectionId } = recommendationsContainer.dataset;
  if (!productId || !sectionId) return;

  const reinitLazyImages = () => {
    window.ORW?.lazyload?.update?.();
  };

  const initCartForms = () => {
    const forms = recommendationsContainer.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        const select = form.querySelector('select[name="id"]');
        if (!select?.value) return;

        const submitBtn = form.querySelector('[type="submit"]');
        const btnText = submitBtn?.querySelector('.add-to-cart-text');
        const originalText = btnText?.textContent;

        if (submitBtn) {
          submitBtn.classList.add('is-adding');
          submitBtn.disabled = true;
        }
        if (btnText) btnText.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(select.value), quantity: 1 }),
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);
            return response.json();
          })
          .then(() => {
            if (submitBtn) {
              submitBtn.classList.remove('is-adding');
              submitBtn.classList.add('is-added');
            }
            if (btnText) btnText.textContent = 'Added!';
            if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
              ajaxCart.load();
            }
            setTimeout(() => {
              if (submitBtn) {
                submitBtn.classList.remove('is-added');
                submitBtn.disabled = false;
              }
              if (btnText) btnText.textContent = originalText;
            }, 2000);
          })
          .catch((error) => {
            console.error('[Product Recommendations] Add to cart failed:', error);
            if (submitBtn) {
              submitBtn.classList.remove('is-adding');
              submitBtn.disabled = false;
            }
            if (btnText) btnText.textContent = originalText;
          });
      });
    });
  };

  const initAddAllButton = () => {
    const addAllBtn = recommendationsContainer.querySelector('.add-all-to-cart');
    if (!addAllBtn) return;

    addAllBtn.addEventListener('click', () => {
      const forms = recommendationsContainer.querySelectorAll('form[action*="/cart/add"]');
      const items = [...forms]
        .map((form) => {
          const select = form.querySelector('select[name="id"]');
          return select?.value;
        })
        .filter(Boolean);

      if (!items.length) return;

      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';

      const payload = { items: items.map((id) => ({ id: Number(id), quantity: 1 })) };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Add to cart failed: ${response.status}`);
          return response.json();
        })
        .then(() => {
          addAllBtn.textContent = 'Added!';
          if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
            ajaxCart.load();
          }
          setTimeout(() => {
            addAllBtn.disabled = false;
            addAllBtn.textContent = 'Add All to Cart';
          }, 2000);
        })
        .catch((error) => {
          console.error('[Product Recommendations] Add all failed:', error);
          addAllBtn.disabled = false;
          addAllBtn.textContent = 'Add All to Cart';
        });
    });
  };

  const recommendationsPlaceholder = recommendationsContainer.querySelector('[data-recommendations-placeholder]');
  if (!recommendationsPlaceholder) {
    initCartForms();
    initAddAllButton();
    return;
  }

  const recommendationsApiUrl = `/recommendations/products?product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}&section_id=${encodeURIComponent(sectionId)}`;

  fetch(recommendationsApiUrl)
    .then((response) => {
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
      return response.text();
    })
    .then((html) => {
      const parsedResponse = document.createElement('div');
      parsedResponse.innerHTML = html;

      const recommendationsContent = parsedResponse.querySelector('[data-recommendations]');
      if (!recommendationsContent?.innerHTML.trim().length) {
        recommendationsContainer.style.display = 'none';
        return;
      }

      recommendationsContainer.innerHTML = recommendationsContent.innerHTML;
      reinitLazyImages();
      initCartForms();
      initAddAllButton();
    })
    .catch((error) => {
      console.error('[Product Recommendations]', error);
      recommendationsContainer.style.display = 'none';
    });
})();
